import React, { FunctionComponent } from "react";
import { colors, ConfigProvider } from "@ui-kit/ConfigProvider/ConfigProvider";
import { Button } from "antd";

interface SessionCountdownButtonProps {
  /**
   * Callback when button is pressed.
   */
  onPress?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  /**
   * Label that appears on button.
   */
  label: string;
  /**
   * If button is in inverse (dark) style
   */
  inverse?: boolean;
}

const SessionCountdownButton: FunctionComponent<
  SessionCountdownButtonProps
> = ({ onPress, label, inverse = false }) => {
  return (
    <ConfigProvider
      themeConfigOverride={{
        components: {
          Button: {
            colorPrimary: inverse ? "none" : colors.white,
            primaryShadow: "0 2px 8px 0px rgba(0, 0, 0, 0.15)",
            fontWeight: 600,
            primaryColor: inverse ? colors.white : colors.neutral800,
            solidTextColor: inverse ? colors.white : colors.neutral800,
            fontSize: 32,
            contentLineHeight: 44,
            borderRadius: 68,
          },
        },
      }}>
      <Button
        style={{
          width: "100%",
          height: "108px",
          padding: "40px 32px",
          border: inverse ? `4px solid ${colors.white}` : "none",
        }}
        onClick={onPress}
        type="primary">
        {label}
      </Button>
    </ConfigProvider>
  );
};

export { SessionCountdownButton };
